import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { get } from '../constants';

import ButtonBase from './ButtonBase';

const ButtonFilled = styled(ButtonBase)`
  ${({ color, textColor }) => css`
    color: ${get(`colors.${textColor}`)};
    background-color: ${get(`colors.${color}`)};
    border: 2px solid ${get(`colors.${color}`)};

    &:hover {
      color: ${get(`colors.${textColor}`)};
      background-color: ${get(`colors.${color}Dark`)};
      border-color: ${get(`colors.${color}Dark`)};
    }

    &:focus {
      color: ${get(`colors.${textColor}`)};
      background-color: ${get(`colors.${color}Dark`)};
      border-color: ${get(`colors.${color}Dark`)};
    }

    &:active {
      color: ${get(`colors.${textColor}`)};
      background-color: ${get(`colors.${color}Darker`)};
      border-color: ${get(`colors.${color}Darker`)};
    }

    &:disabled {
      color: ${get(`colors.text.textBlack30`)};
      background-color: ${get(`colors.${color}Light`)};
      border-color: ${get(`colors.${color}Light`)};
      cursor: not-allowed;
    }
  `}
`;

ButtonFilled.propTypes = {
  color: PropTypes.string,
  textColor: PropTypes.string,
  ...ButtonBase.propTypes,
};

ButtonFilled.defaultProps = {
  color: 'primary',
  textColor: 'white',
};

export default ButtonFilled;
